export default {"src":"/_next/static/media/gl-carousel-1-3.ab9cbf58.svg","height":38,"width":32,"blurWidth":0,"blurHeight":0};